import CorporateDocumentForm from './form'

export default CorporateDocumentForm;